import React, { useEffect, useState, useContext } from 'react';
import ReactDOM from 'react-dom';
import { Button, Row, Col, message, Modal } from 'antd';
import AppContext from "../AppContext"
import moment from 'moment';
import 'moment-timezone'
import "../../css/attendance.css";
import { checkInAttendance, checkOutAttendance, onGetAttendancelistbyuser } from '../../Controller/Attendance';
import { getUserbyId } from '../../Controller/Management/UserProf_Ctrl';
import { onGetShiftById } from '../../Controller/Management/ShiftManagement';
import { onGetHolidayByDate } from '../../Controller/Management/HolidaysManagement';
import T_Error from "../404";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Collapse,
    IconButton,
    Box,
} from '@mui/material';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';

export default function Attendance(prop) {
    //===== VARIABLE ====
    const global = useContext(AppContext)
    const userid = global.UserIdentity.userid;
    const [currentusername, setcurrentusername] = useState("");

    const companyid = global.UserIdentity.companyid;
    const [isMaintenance, setIsMaintenance] = useState(false);      // Used for maintenance
    const [datasource, setDataSource] = useState({});
    const [flexibledata, setFlexibledata] = useState([])
    const [branchnow, setbranchnow] = useState("");
    const [ipnow, setipnow] = useState("");
    const [time, setTime] = useState(moment());
    const [starttime, setstarttime] = useState("");
    const [worktype, setworktype] = useState("");

    const [localip, setlocalip] = useState("");

    const [inButton, setInButton] = useState(true)
    const [astyle, setastyle] = useState("");
    const [durationperweek, setdurationperweek] = useState("");
    const [totalworking, setTotalworking] = useState("");
    //====== MODAL ========
    const [modalVisible, setModalVisible] = useState("");
    const [modalVisible2, setModalVisible2] = useState("");

    const { Panel } = Collapse;


    // useEffect(() => {
    //     onCSSadjustment();

    //     // Setup interval to update time every second
    //     const intervalId = setInterval(() => {
    //         let today = moment();
    //         setTime(today);
    //     }, 1000);

    //     // Cleanup function to clear the interval when component unmounts
    //     return () => clearInterval(intervalId);

    //     // Initial data fetch
    //     onRefresh();
    // }, []);

    function getLocalIP() {
        window.RTCPeerConnection = window.RTCPeerConnection
            || window.mozRTCPeerConnection
            || window.webkitRTCPeerConnection;

        const pc = new RTCPeerConnection({ iceServers: [] });
        pc.createDataChannel('');
        pc.createOffer(pc.setLocalDescription.bind(pc), () => { });

        pc.onicecandidate = ice => {
            if (!ice) {
                console.log('No ICE Candidate generated');
                setlocalip("No ICE Candidate generated")
                return;
            }
            if (!ice.candidate) {
                console.log('ICE Candidate missing, likely end of candidates');
                setlocalip("ICE Candidate missing, likely end of candidates")
                return;
            }
            if (!ice.candidate.candidate) {
                console.log('No candidate information in the ICE candidate');
                setlocalip("No candidate information in the ICE candidate")
                return;
            }
            const ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3})/;
            const match = ipRegex.exec(ice.candidate.candidate);
            if (match) {
                console.log('My IP:', match[1]);
                setlocalip(match[1])
            } else {
                console.log('IP Address format not found in candidates');
                setlocalip("IP Address format not found in candidates")
            }
            pc.onicecandidate = () => { }; // Stop further candidates
        };
    }






    // useEffect for fetching data
    useEffect(() => {
        onCSSadjustment();
        onRefresh();

        // if (userid == "60ebde816d150ba31d16a879") {
        //     window.location.href = "http://punchcard/?user=nicholas&org=naxgroup";
        //     //window.location.href = "www.google.com.my";

        // }

        getLocalIP();
    }, []); // This useEffect will re-run whenever 'time' changes

    // // useEffect for updating time
    // useEffect(() => {
    //     // Setup interval to update time every second
    //     const intervalId = setInterval(() => {
    //         let today = moment();
    //         setTime(today);
    //     }, 1000);

    //     // Cleanup function to clear the interval when component unmounts
    //     return () => {
    //         clearInterval(intervalId);
    //     };
    // }, []); // This useEffect will only run once on mount

    const DateTimeComponent = () => {
        const [time, setTime] = useState(moment());

        useEffect(() => {
            const intervalId = setInterval(() => {
                setTime(moment());
            }, 1000);

            // Cleanup function to clear the interval when the component unmounts
            return () => clearInterval(intervalId);
        }, []); // Empty dependency array to run the effect only once on mount

        return (
            <div>
                <p className="date">{time.format('YYYY-MM-DD ddd')}</p>
                <p className="time">{time.format('HH:mm:ss')}</p>
            </div>
        );
    };

    //==== FUNCTIONS =====
    const onCSSadjustment = () => {
        let element = document.getElementsByClassName("attendanceForm")[0];
        ReactDOM.findDOMNode(element.parentElement.parentElement).classList.add("attendanceparent");
    }

    const onClick = (act) => {
        switch (act) {
            case "in":
                setInButton(true)
                onAttendanceIn();
                break;
            case "out":
                onAttendanceOut();
                setInButton(false)
                break;
            default:
                break;
        }
    }

    const onTestAutopunch = (act) => {

        if (branchnow == "Tera") {
            window.open(`https://punchtera.glivestreaming.com/?user=${userid}&org=${companyid}&name=${currentusername}`, '_blank').focus();
        }
        else if (branchnow == "Nic House") {
            window.open(`https://punchnichome.glivestreaming.com/?user=${userid}&org=${companyid}&name=${currentusername}`, '_blank').focus();
        }
        else if (branchnow == "Nax")
        {
            window.open(`https://punchnax.glivestreaming.com/?user=${userid}&org=${companyid}&name=${currentusername}`, '_blank').focus();
       
        }
    }

    const convertSecondsToTime = (seconds) => {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);

        if (hours > 0) {
            return `${hours}h ${minutes}m`;
        }

        return `${minutes}m`;
    };

    // Function to format timestamp to time
    const formatTimestampToTime = (timestamp, dts) => {
        const momentObj = moment.unix(timestamp);
        const formattedTime = momentObj.format('HH:mm');

        // Check if the date is different from dts
        if (momentObj.format('YYYY-MM-DD') !== moment.unix(dts).format('YYYY-MM-DD')) {
            return `${momentObj.format('D/M')} ${formattedTime} AM`;
        }

        return formattedTime;
    };

    // Function to group and count by a specific key
    const groupAndCount = (data, key) => {
        const grouped = {};

        console.log("pass in data", data)
        data.forEach(item => {
            const keyValue = item[key];

            if (!grouped[keyValue]) {
                grouped[keyValue] = {
                    dts: item.dts,
                    count: 0,
                    totalWorkduration: 0,
                    totalExtra: 0,
                    details: []
                };
            }

            // Include only specified fields in 'detail'
            const detail = {
                punchin: formatTimestampToTime(item.punchin, item.dts),
                punchout: formatTimestampToTime(item.punchout, item.dts),
                workduration: item.workduration,
                extra: item.extra
            };

            grouped[keyValue].count++;
            grouped[keyValue].totalWorkduration += item.workduration;
            grouped[keyValue].totalExtra += item.extra;
            grouped[keyValue].details.push(detail);
        });

        return grouped;
    };

    const onRefresh = () => {
        setInButton(true)
        return Promise.all([onGetAttendancelistbyuser({ username: userid }), getUserbyId({ userid: userid })])
            .then(([val, val2]) => {
                let result = val?.data[0];
                if (result != undefined) {
                    // Type = Att then go to punchout, set datasource
                    let type = result.type;
                    let sections = ''
                    if ((['AL', 'MC', 'EL', 'UL', "HL", 'Trip'].includes(type))) {
                        if (result.sections) {
                            sections = result.sections
                        }
                        else {
                            sections = 'full'
                        }
                    }

                    if (type == "Att" || type == "Free" || sections == "half" || sections == '') {
                        //===== IF GOT RESULT ON DESC =========
                        let punchout = result.punchout;
                        if (punchout == "") {
                            setDataSource(result);
                        }
                    }
                    else {
                        //=== CHECK DATE ====
                        let dts = result.dts;
                        let timenow = moment().set({ hour: 0, minute: 0, second: 0 }).unix();
                        //=== IF SAME TIME =====(MEANS TODAY  AL, EL, MC)
                        if (dts == timenow) {
                            setDataSource(result);
                        }
                    }
                }

                // Filter records with 'dts' within the current week and current year
                const currentWeekData = val?.data.filter(item => {
                    // const dtsMoment = moment.unix(item.dts);
                    // const isCurrentYear = dtsMoment.year() === moment().year();
                    // const isCurrentWeek = dtsMoment.isoWeek() === moment().isoWeek();
                    // return isCurrentYear && isCurrentWeek;

                    const dtsMoment = moment.unix(item.dts);

                    // Get the start and end of the current ISO week
                    const startOfWeek = moment().startOf('isoWeek');
                    const endOfWeek = moment().endOf('isoWeek');
                
                    // Check if 'dts' falls within the range
                    return dtsMoment.isBetween(startOfWeek, endOfWeek, 'day', '[]'); // Inclusive of boundaries
                
                });

                var leavecount = 0
                var totalbyweek = 0
                // Group data by 'dts' and create an array of objects with required details
                const groupedData = Object.values(
                    currentWeekData.reduce((acc, item) => {
                        const dts = item.dts;
                        if (!acc[dts]) {
                            acc[dts] = { dts, detail: [], totalWorkduration: 0, totalExtra: 0, count: 0 };
                        }

                        let sections = ''
                        if ((['AL', 'MC', 'EL', 'UL', "HL", 'Trip'].includes(item.type))) {
                            if (item.sections) {
                                sections = item.sections
                            }
                            else {
                                sections = 'full'
                            }
                        }
                        const detailItem = {
                            punchin: formatTimestampToTime(item.punchin, item.dts),
                            punchout: item.punchout == '' ? '' : formatTimestampToTime(item.punchout, item.dts),
                            workduration: item.workduration,
                            extra: item.extra,
                            type: item.type,
                            sections: sections
                        };


                        acc[dts].detail.push(detailItem);
                        acc[dts].totalWorkduration += item.workduration;
                        acc[dts].totalExtra += item.extra;
                        acc[dts].count += 1;
                        totalbyweek += item.workduration

                        // Check if dts is a timestamp not in Satuday or Sunday
                        if (moment.unix(dts).isoWeekday() <= 5) {
                            // Count records with type 'AL', 'MC', 'EL', 'UL' on weekdays
                            if (['AL', 'MC', 'EL', 'UL', "HL", 'Trip'].includes(item.type)) {
                                console.log("leave item, ",item)
                                if(item.sections)
                                {
                                    if(item.sections =="half")
                                    {
                                        leavecount += 0.5;
                                    }
                                    else if (item.sections =="full")
                                    {
                                        leavecount += 1;
                                    }
                                }
                              
                                console.log("leave ++")
                            }
                        }


                        // Sort the 'detail' array by punchin timestamp in descending order
                        acc[dts].detail.sort((a, b) => {
                            const timestampA = moment(b.punchin, 'HH:mm:ss').unix();
                            const timestampB = moment(a.punchin, 'HH:mm:ss').unix();
                            return timestampA - timestampB;
                        });



                        return acc;
                    }, {})
                );

                // Sort the groupedData array by dts in descending order
                groupedData.sort((a, b) => b.dts - a.dts);
                setFlexibledata(groupedData)
                // Log the result
                console.log("groupedData >>>", groupedData);

                var holidays = 0

                if (val.holidays) {
                    val.holidays.forEach(value => {

                        if (moment(value.date).day() != 0 && moment(value.date).day() != 6) {
                            holidays += 1
                        }
                    })
                }
                console.log("val >>>", val)
                console.log("val2 >>>", val2)

                if (val2.data) {
                    if (val2.data.userid) {
                        setcurrentusername(val2.data.userid)
                    }

                }

                // var holidaysobject = {
                //     startdate: moment().startOf("week").format('YYYY/MM/DD'), 
                //     enddate: moment().endOf("week").format('YYYY/MM/DD'), 
                //     companyid:val2.data.companyid
                // }

                // onGetHolidayByDate(holidaysobject)
                // .then(x => {

                //     if(x)
                //     {
                //         x.data.forEach(value => {

                //             if(moment(value.date).day() != 0 && moment(value.date).day() != 6)
                //             {
                //                 holidays += 1
                //             }
                //         })
                //     }


                //     console.log("holidaysresult >>>", x)
                // })



                console.log("totalbyweek >>>>", totalbyweek)

                console.log("branchnow >>>>", val.branchnow)
                setbranchnow(val.branchnow)
                setipnow(val.ipnow)
                // 20210826 Get User start work time
                let result1 = val2?.data;
                let usershiftid = result1["shift"];

                onGetShiftById({ shiftid: usershiftid })
                    .then(x => {
                        console.log("Shift info", x)
                        if (x.status == "err") { }
                        else {
                            let start = x.data[0]?.startworktime;
                            let worktype = x.data[0]?.worktype
                            console.log("holidays >>>", holidays)
                            let durationperweek = x.data[0]?.durationperweek
                            console.log("durationperweek >>>", durationperweek)
                            let workhourperday = durationperweek * 3600 / 5

                            // // Array of dates (in the format 'YYYY-MM-DD')
                            // const importantDates = ['2024-01-01'];

                            // // Get the current date
                            // const currentDate = moment();

                            // // Get the ISO week of the current date
                            // const isoWeekCurrent = currentDate.isoWeek();

                            // // Check if the current week includes any of the important dates
                            // const includesImportantDate = importantDates.some(date => {
                            //     const isoWeekDate = moment(date).isoWeek();
                            //     return isoWeekDate === isoWeekCurrent;
                            // });

                            // if(includesImportantDate)
                            // {
                            //     leavecount += 1
                            // }


                            console.log("totalbyweek >>>", totalbyweek)

                            console.log("leavecount >>>", leavecount)

                            durationperweek = (durationperweek * 3600) - totalbyweek - (workhourperday * leavecount) - (workhourperday * holidays)
                            // durationperweek = (durationperweek * 3600) - totalbyweek  - (workhourperday * holidays)

                            if (durationperweek > 0) {
                                setastyle(`color:'white', backgroundColor:'red'`)
                            }
                            else {
                                setastyle()
                            }
                            setworktype(worktype)
                            setdurationperweek(durationperweek)
                            setstarttime(start);

                        }
                    })

                setInButton(false)
            })
            .catch(err => {
                setIsMaintenance(true);
            });


    }

    //===== IN ======
    const onAttendanceIn = () => {
        let inTime = moment().unix();
        //===== IF ATTENDANCE NOT FOUND ======
        let values = {
            username: userid
        }

        if (datasource.punchout == "" && (datasource.type == "Att" || datasource.type == "WFH")) {
            return message.error("You haven't punch out");
        }
        else if (datasource.type == "MC" || datasource.type == "EL" || datasource.type == "AL" || datasource.type == "UL" || datasource.type == "HL" || datasource.type == "Trip") {
            let leavetype = "";
            if (datasource.sections) {
                if (datasource.sections == "full") {
                    switch (datasource.type) {
                        case "MC":
                            leavetype = "MC";
                            break;
                        case "AL":
                            leavetype = "Annual Leave";
                            break;
                        case "EL":
                            leavetype = "Emergency Leave";
                            break;
                        case "UL":
                            leavetype = "Unpaid Leave";
                            break;
                        case "HL":
                            leavetype = "Hospitalisation leave";
                            break;
                        case "Trip":
                            leavetype = "Working Trip";
                            break;
                    }
                    return message.success(`You are on ${leavetype} today`);
                }
            }

        }

        //====== TO CHECK START WORK TIME ========
        // let startdts    = dts + starttime;
        // let timediff    = time.diff(moment.unix(startdts), "minutes");
        //==== BEFORE 1 HOURS CAN PUNCH CARD ======
        // if(timediff < -60){
        //     return message.error("You cannot punch in this time");
        // }

        checkInAttendance(values)
            .then(val => {
                if (val.status == "err") {
                    if (val.msg == "Record exists") {
                        message.error("You already punch in");
                    }
                    else {
                        return message.error(val.msg);
                    }
                }
                else {
                    message.success(val.msg);
                    onRefresh();
                }
            })
            .catch(err => {
                message.error("Server down");
            });
    }

    //====== OUT ======
    const onAttendanceOut = () => {
        if (Object.keys(datasource).length === 0) {
            let outTime = moment().unix();
            let values = {
                username: userid
            }

            checkOutAttendance(values)
                .then(val => {
                    if (val.status == "err") {
                        message.error(val.msg);
                        setModalVisible(false);
                    }
                    else {
                        message.success(val.msg);
                        setModalVisible(false);
                        setTotalworking("");
                        onRefresh();
                        setDataSource({});
                    }
                })
                .catch(err => {
                    message.error("Server down");
                });
        }
        else {
            if (datasource.punchout == "" && (datasource.type == "Att" || datasource.type == "WFH")) {
                let outTime = moment();
                let punchin = moment.unix(Number(datasource.punchin));

                let total = moment.duration(outTime.diff(punchin));
                var hour = parseInt(total.asHours());
                var minute = parseInt(total.asMinutes() % 60);

                setTotalworking(`${hour} hour and ${minute} minutes`);
                //===== Modal confirmation =====
                setModalVisible(true);
            }
            else if (datasource.type == "MC" || datasource.type == "EL" || datasource.type == "AL" || datasource.type == "UL" || datasource.type == "HL" || datasource.type == "Trip") {
                let leavetype = "";
                if (datasource.sections) {
                    if (datasource.sections == "full") {
                        switch (datasource.type) {
                            case "MC":
                                leavetype = "MC";
                                break;
                            case "AL":
                                leavetype = "Annual Leave";
                                break;
                            case "EL":
                                leavetype = "Emergency Leave";
                                break;
                            case "UL":
                                leavetype = "Unpaid Leave";
                                break;
                            case "HL":
                                leavetype = "Hospitalisation leave";
                                break;
                            case "Trip":
                                leavetype = "Working Trip";
                                break;
                        }
                        return message.success(`You are on ${leavetype} today`);
                    }
                }
            }
        }
    }

    //===== ATTENDANCE FORM =======
    const attendanceForm = () => {
        return (
            <div className={"attendanceForm"}>
                <div id="clock">

                    <p className="text" style={{ fontSize: "20px" }}>NAXGO - ATTENDANCE</p>
                    {/* <p className="date">{time.format("YYYY-MM-DD ddd")}</p>
                    <p className="time">{time.format("HH:mm:ss")}</p> */}
                    <DateTimeComponent></DateTimeComponent>
                    <p className="time" style={{ fontSize: "15px" }}>{ipnow}, {branchnow}</p>
                    {/* <p className="time" style={{ fontSize: "15px" }}>{ipnow}</p> */}
                    <p>{datasource.punchin != undefined && datasource.punchin != "" ? `Punch In Time: ${moment.unix(datasource.punchin).format("HH:mm")}, ${datasource.branchin == '' ? "Outside" : datasource.branchin}` : `Punch In Time: `}</p>
                    {/* 
                    {(() => {
                        if (datasource.punchin != undefined && datasource.punchin != "") {
                            return (
                                <>
                                   
                                </>
                            )
                        }
                    })()} */}
                    {
                        userid == "61d25883cddb0fb407663477" || userid == "60ebde816d150ba31d16a879" || userid == "60eba6f748c6fe1a99ce6994" ?
                            <>
                                <p>Local : {localip}</p>
                            </>
                            :
                            <>
                            </>
                    }
                    {(() => {
                        if (worktype == "flexible") {
                            return (
                                <>
                                    <p className='time' style={{ fontSize: "15px" }}>
                                        <a onClick={() => { setModalVisible2(true) }}>{durationperweek > 0 ? `Remaining : ${convertSecondsToTime(durationperweek)} ` : `Enough : +${convertSecondsToTime(durationperweek * -1)} `}</a>
                                    </p>
                                </>
                            )
                        }
                    })()}
                    <div id="buttons">
                        <Row gutter={["8", "8"]}>


                            {(() => {
                                if (datasource.punchin == undefined || datasource.punchin == "") {
                                    return (
                                        <>
                                            {
                                                inButton == true ?
                                                    <>
                                                    </>
                                                    :
                                                    <>
                                                        <Col span="24">
                                                            <Button type={"primary"}
                                                                disabled={inButton}
                                                                onClick={() => { onClick("in") }}> In </Button>
                                                        </Col>
                                                    </>
                                            }
                                        </>
                                    )
                                }
                            })()}

                            {/* <Col span="24">
                                <Button type={"primary"}
                                    // disabled={inButton} 
                                    onClick={() => { onClick("in") }}> In </Button>
                            </Col> */}
                            <br></br>
                            <br></br>
                            {(() => {
                                if (datasource.punchin != undefined && datasource.punchin != "") {
                                    return (
                                        <>
                                            <Col span="24">
                                                <Button type={"danger"} onClick={() => { onClick("out") }}> Out </Button>
                                            </Col>    </>
                                    )
                                }
                            })()}

                            {
                                branchnow == "Tera" || branchnow == "Nic House" || branchnow == "Nax" ?
                                    <>
                                        <Col span="24">
                                            <Button type={"danger"} onClick={() => { onTestAutopunch() }}> Pin </Button>
                                        </Col>
                                    </>
                                    :
                                    <>
                                    </>
                            }

                        </Row>
                    </div>

                </div>
            </div>

        )
    }



    const Row1 = ({ data }) => {
        // Check if data.dts corresponds to the current day
        const isCurrentDay = moment.unix(data.dts).isSame(moment(), 'day');

        // Set the default value for 'open' based on whether it's the current day
        const [open, setOpen] = React.useState(isCurrentDay);


        return (
            <>
                <TableRow>
                    <TableCell>
                        <IconButton size="small" onClick={() => setOpen(!open)}>
                            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                        </IconButton>
                    </TableCell>
                    <TableCell>{data ? `${moment.unix(data.dts).format("MM/DD ddd")}` : ''}</TableCell>
                    <TableCell>{data ? convertSecondsToTime(data.totalWorkduration) : ''}</TableCell>
                    <TableCell>{data ? convertSecondsToTime(data.totalExtra) : ''}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={4}>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            <Box margin={1}>
                                {/* <Typography variant="h6" gutterBottom component="div">
                                    Details
                                </Typography> */}
                                <Table size="small" aria-label="purchases">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>In</TableCell>
                                            <TableCell>Out</TableCell>
                                            <TableCell>Work</TableCell>
                                            <TableCell>Extra</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            data ?
                                                data.detail.map((detailItem, index) => (
                                                    detailItem.sections == 'full' ?

                                                        <TableRow key={index}>
                                                            <TableCell><a>{detailItem.type}</a></TableCell>
                                                            <TableCell><a>{"Full"}</a></TableCell>
                                                        </TableRow>
                                                        :
                                                        detailItem.sections == 'half' ?
                                                            <TableRow key={index}>
                                                                <TableCell><a>{detailItem.type}</a></TableCell>
                                                                <TableCell><a>{"Half"}</a></TableCell>
                                                            </TableRow>
                                                            :
                                                            detailItem.type == 'Free' ?
                                                                <TableRow key={index}>
                                                                    <TableCell>{"Free"}</TableCell>
                                                                    <TableCell>{""}</TableCell>
                                                                    <TableCell>{convertSecondsToTime(detailItem.workduration)}</TableCell>
                                                                    <TableCell>{convertSecondsToTime(detailItem.extra)}</TableCell>
                                                                </TableRow>
                                                                :
                                                                <TableRow key={index}>
                                                                    <TableCell>{detailItem.punchin}</TableCell>
                                                                    <TableCell>{detailItem.punchout}</TableCell>
                                                                    <TableCell>{convertSecondsToTime(detailItem.workduration)}</TableCell>
                                                                    <TableCell>{convertSecondsToTime(detailItem.extra)}</TableCell>
                                                                </TableRow>


                                                ))
                                                :
                                                ''
                                        }
                                    </TableBody>
                                </Table>
                            </Box>
                        </Collapse>
                    </TableCell>
                </TableRow>
            </>
        );
    };

    const DataTable = ({ data }) => {
        return (
            <TableContainer component={Paper}>
                <Table aria-label="collapsible table">
                    <TableHead>
                        <TableRow>
                            <TableCell />
                            <TableCell>Date</TableCell>
                            <TableCell>Total Work</TableCell>
                            <TableCell>Total Extra</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((row) => (
                            <Row1 key={row.dts} data={row} />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        );
    };

    //===== MODAL =======
    const onHistoryModal = () => {
        return (
            <Modal
                title={"Records"}
                visible={modalVisible2}
                onCancel={handleOk2}
                footer={
                    <Button key="back" onClick={handleOk2}>
                        Return
                    </Button>
                }
            >
                {
                    flexibledata.length > 0 ?
                        <DataTable data={flexibledata} />
                        :
                        ''
                }

            </Modal>
        );
    }

    const handleOk2 = () => {
        setModalVisible2(false)
    }


    //===== MODAL =======
    const onModal = () => {
        return (
            <Modal
                title={"Punch Out"}
                visible={modalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
            >{ModalContent()}
            </Modal>
        )
    }

    const ModalContent = () => {
        return (
            <div>
                {`Your total working is ${totalworking}, are you sure you want to punch out?`}
            </div>
        )
    }

    const handleOk = () => {
        let outTime = moment().unix();
        let values = {
            username: userid,
            punchout: outTime
        }

        checkOutAttendance(values)
            .then(val => {
                if (val.status == "err") {
                    message.error(val.msg);
                    setModalVisible(false);
                }
                else {
                    message.success(val.msg);
                    setModalVisible(false);
                    setTotalworking("");
                    onRefresh();
                    setDataSource({});
                }
            });
    }

    const handleCancel = () => {
        setModalVisible(false);
        setTotalworking("");
    }

    return (
        <>
            {(() => {
                if (isMaintenance) {
                    return (<T_Error />)
                }
                else {
                    return (
                        <>

                            {onModal()}
                            {onHistoryModal()}
                            {attendanceForm()}
                        </>
                    )
                }
            })()}
        </>
    )
}